import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { emptyLocatiomModel, ILocationModel } from './LocationsApp';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer';
import { ISearchParam } from '../BaseApp';

interface ILocationsState {
    locations: ILocationModel[],
    selectedLocations: ILocationModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string
}

const initialState: ILocationsState = {
    locations: [],
    selectedLocations: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const locationsSlice = createSlice({
    name: "locations",
    initialState,
    reducers: {
        updateAllLocations: (state: ILocationsState, action: PayloadAction<Array<ILocationModel>>) => {
            state.locations = action.payload
        },
        addNewLocation: (state: ILocationsState, action: PayloadAction<ILocationModel>) => {
            let locations = state.locations

            if (locations.filter(location => location.id === action.payload.id).length === 0){
                state.locations.push(action.payload)
            }

        },
        deleteLocation: (state: ILocationsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let locations = state.locations

            locations = locations.filter(item => item.id !== payload.id)

            state.locations = locations

        },
        updateLocation: (state: ILocationsState, action: PayloadAction<ILocationModel>) => {
            let locations = state.locations
            
            if (locations && locations.length > 0){
                locations.map((location) => {
                    if (location.id === action.payload.id){

                        const locationIndex = locations.findIndex(location => location.id === action.payload.id)
                        locations[locationIndex] = action.payload

                    }
                })
            }

            state.locations = locations

        },
        updateLocationsLoadingStatus: (state: ILocationsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateLocationsPagination: (state: ILocationsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateLocationsSearch: (state: ILocationsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateLocationsSearchParams: (state: ILocationsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedLocations: (state: ILocationsState, action: PayloadAction<ILocationModel[]>) => {
            state.selectedLocations = action.payload
        },
    }
})

/**
 * Return all locations
 */
export const useReturnAllLocations = () => useSelector((state: RootState) => state.locations.locations)

/**
 * Retrun single location
 */
export const useReturnSingleLocation = (id: number) => {
    const locations = useReturnAllLocations()

    let location: ILocationModel = emptyLocatiomModel

    if (locations.length > 0){
        locations.map((singleLocation) => {
            if (singleLocation.id === id){
                location = singleLocation
            }
        })
    }

    return location

}

export const returnSingleLocation = (id: number, locations: ILocationModel[]) => {

    let location: ILocationModel = emptyLocatiomModel

    if (locations.length > 0){
        locations.map((singleLocation) => {
            if (singleLocation.id === id){
                location = singleLocation
            }
        })
    }

    return location

}

/**
 * Return locations loading status
 */
export const useReturnLocationsLoadingStatus = () => useSelector((state: RootState) => state.locations.loading)

/**
 * Return locations pagination
 */
export const useReturnLocationsPagination = () => useSelector((state: RootState) => state.locations.pagination)

/**
 * Return locations search
 */
export const useReturnLocationsSearch = () => useSelector((state: RootState) => state.locations.search)

/**
 * Return locations search params
 */
export const useReturnLocationsSearchParams = () => useSelector((state: RootState) => state.locations.searchParams)

/**
 * Return selected locations
 */
export const useReturnSelectedLocations = () => useSelector((state: RootState) => state.locations.selectedLocations)

export const { updateAllLocations, addNewLocation, updateLocation, updateLocationsLoadingStatus, updateLocationsPagination, deleteLocation, updateLocationsSearch, updateLocationsSearchParams, setSelectedLocations } = locationsSlice.actions
export default locationsSlice.reducer